import {
  GridDashboardItem,
  HistoricalUtrs,
} from '../../types/insight-custom-dashboard';
import { IntegrationData } from '@g17eco/types/app-integration';
import { UniversalTrackerModalTab } from '@g17eco/types/universalTrackerModal';
import { ChartUtrData } from './items/types';
import type { GridItemContext } from '@g17eco/types/dashboard';
import { EditingWrapper } from './EditingWrapper';
import { GetWidget } from './GetWidget';

export interface UtrvHistoryModalProps {
  item: GridDashboardItem;
  utrData?: HistoricalUtrs;
  activeTab?: UniversalTrackerModalTab['navId'];
}

/**
 * Props for GridItem component.
 * Uses GridItemContext to group stable/shared props, reducing prop drilling.
 */
export interface GridItemProps {
  /** The dashboard item to render */
  item: GridDashboardItem;
  /** UTR data for charts and tables */
  utrsData: ChartUtrData[];
  /** Integration data for external data sources */
  integrationsData?: IntegrationData;
  /** Whether the dashboard is in editing mode */
  isEditing: boolean;
  /** Shared context - stable props that don't change per-item */
  gridItemContext: GridItemContext;
  /** Callback to remove an item */
  onItemRemove?: (item: GridDashboardItem) => void;
  /** Callback to edit an item */
  handleClickEdit?: (item: GridDashboardItem) => void;
  /** Callback to duplicate an item */
  handleClickDuplicate?: (item: GridDashboardItem) => void;
  /** Callback to open the UTRV history modal */
  handleOpenUtrvHistoryModal: (params: UtrvHistoryModalProps) => void;
  /** Custom action button component */
  actionBtn?: React.ElementType<{ item: GridDashboardItem }>;
  /** Custom no-data view component */
  NoDataView?: React.ElementType<{ item: GridDashboardItem; questionReference?: JSX.Element | null }>;
  /** Callback for editing item in disaggregated view */
  onEditItem?: (id: string) => void;
}

export const GridItem = (props: GridItemProps) => {
  const { isEditing, item, onItemRemove, handleClickEdit, handleClickDuplicate } = props;

  if (isEditing) {
    return (
      <EditingWrapper
        item={item}
        onItemRemove={onItemRemove}
        handleClickEdit={handleClickEdit}
        handleClickDuplicate={handleClickDuplicate}
      >
        <GetWidget {...props} />
      </EditingWrapper>
    );
  }

  return <GetWidget {...props} />;
};
